/**
 * @desc 通过sku和供应商IdName获取sku物流信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.logisticsSupplierSkuFacadeImpl.getLogisticsSkuInfoBySkuAndSupplierIdName.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/logisticsSku/bySkuAndSupplier`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
